import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useState } from "react";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import DashboardPage from "./pages/DashboardPage";
import InventoryPage from "./pages/InventoryPage";
import TransactionsPage from "./pages/Transaction/TransactionsPage";
import OutletPage from "./pages/Outlet/OutletPage";
import OutletForm from "./pages/Outlet/OutletForm";
import EditOutletForm from "./pages/Outlet/EditOutletForm";
import ShiftPage from "./pages//Shift/ShiftPage";
import CreateShift from "./pages/Shift/CreateShift";
import EditShift from "./pages/Shift/EditShift";
import KaryawanPage from "./pages/Karyawan/KaryawanPage";
import CreateKaryawan from "./pages/Karyawan/CreateKaryawan";
import EditKaryawan from "./pages/Karyawan/EditKaryawan";
import ShiftKaryawan from "./pages//Karyawan/ShiftKaryawan";
import ShiftingKaryawan from "./pages/Karyawan/ShiftingKaryawan";
import DistributorPage from "./pages/Distributor/DistributorPage";
import CreateDistributor from "./pages/Distributor/CreateDistributor";
import EditDistributor from "./pages/Distributor/EditDistributor";
import ObatPage from "./pages/Obat/ObatPage";
import RegisterObat from "./pages/Obat/RegisterObat";
import CreateObat from "./pages/Obat/CreateObat";
import ObatDetail from "./pages/Obat/ObatDetail";
import EditObat from "./pages/Obat/EditObat";
import CreatePaket from "./pages/Resep/CreatePaket";
import UpdatePaket from "./pages/Resep/UpdatePaket";
import ResepPage from "./pages/Resep/ResepPage";
import ResepDetail from "./pages/Resep/ResepDetail";
import StockOpname from "./pages/StockOpname/StockOpnamePage";
import CreateStockOpname from "./pages/StockOpname/CreateStockOpname";
import PurchaseOrderList from "./pages/PurchaseOrder/PurchaseOrderList";
import PurchaseOrderDetail from "./pages/PurchaseOrder/PurchaseOrderDetail";
import PurchaseOrderDetails from "./pages/PurchaseOrder/PurchaseOrderDetails";
import PurchasingOrderFA from "./pages/PurchaseOrder/PurchasingOrderFA";
import ReceivePO from "./pages/PurchaseOrder/ReceivePO";
import CreateInvoice from "./pages/Invoice/CreateInvoice";
import InvoiceList from "./pages/Invoice/InvoiceList";
import InvoiceDetail from "./pages/Invoice/InvoiceDetail";
import InvoiceFormPO from "./pages/Invoice/InvoiceFormPO";
import Logs from "./pages/Log/Logs";
import LogOther from "./pages/Log/LogOther";
import LogsPage from "./pages/Log/LogPage";
import SalesReport from "./pages/Report/SalesReport";
import DetailedReportPage from "./pages/DetailedReportPage";
import LoginPage from "./pages/LoginPage";
import MonthlyReport from "./pages/Report/MonthlyReport";
import RebalancePage from "./pages/Rebalance/RebalancePage";
import CreateRebalance from "./pages/Rebalance/CreateRebalance";
import DetailRebalance from "./pages/Rebalance/DetailRebalance";

const NotFoundRedirect = () => {
  const location = useLocation();

  // Mengecualikan route "/enterprise/resepdetail/:name/:outlet" dari redirect
  if (location.pathname.startsWith("/obat-paket/paket/detail/")) {
    return null; // Tidak redirect, tetap di halaman
  }

  return <Navigate to="/" />; // Redirect ke halaman utama jika tidak cocok
};

function App() {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  // Fungsi untuk mengecek apakah pengguna sudah login
  const isAuthenticated = () => {
    return !!localStorage.getItem("token");
  };

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen((prev) => !prev);
  };

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-50/50 font-sans overflow-x-hidden">
        {isAuthenticated() ? (
          <div className="flex min-h-screen relative overflow-x-hidden">
            <Sidebar
              isMobileOpen={isMobileSidebarOpen}
              onClose={closeMobileSidebar}
            />
            <div className="flex-1 lg:ml-64 ml-0 flex flex-col min-w-0 transition-all duration-300">
              <Header onToggleSidebar={toggleMobileSidebar} />
              <div className="flex-1 p-3 md:p-6 overflow-y-auto">
                <Routes>
                  {/* Root Route */}
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/inventory" element={<InventoryPage />} />
                  <Route path="/enterprise/outlet" element={<OutletPage />} />
                  <Route
                    path="/enterprise/outlet/create-outlet"
                    element={<OutletForm />}
                  />
                  <Route
                    path="/enterprise/createoutlet"
                    element={<OutletForm />}
                  />
                  <Route
                    path="/enterprise/outlet/edit-outlet/:id"
                    element={<EditOutletForm />}
                  />
                  <Route path="/enterprise/shift" element={<ShiftPage />} />
                  <Route
                    path="/enterprise/shift/create-shift"
                    element={<CreateShift />}
                  />
                  <Route
                    path="/enterprise/shift/edit-shift/:id"
                    element={<EditShift />}
                  />
                  <Route
                    path="/enterprise/karyawan"
                    element={<KaryawanPage />}
                  />
                  <Route
                    path="/enterprise/karyawan/createkaryawan"
                    element={<CreateKaryawan />}
                  />
                  <Route
                    path="/enterprise/karyawan/editkaryawan/:id"
                    element={<EditKaryawan />}
                  />
                  <Route
                    path="/enterprise/karyawan/shiftingkaryawan"
                    element={<ShiftingKaryawan />}
                  />
                  <Route
                    path="/enterprise/distributor"
                    element={<DistributorPage />}
                  />
                  <Route
                    path="/enterprise/distributor/create-distributor"
                    element={<CreateDistributor />}
                  />
                  <Route
                    path="/enterprise/distributor/edit-distributor/:id"
                    element={<EditDistributor />}
                  />

                  {/* Transaction Route */}
                  <Route path="/transactions" element={<TransactionsPage />} />

                  {/* Obat Route */}
                  <Route path="/obat-paket/obat" element={<ObatPage />} />
                  <Route
                    path="/obat-paket/obat/register"
                    element={<RegisterObat />}
                  />
                  <Route
                    path="/obat-paket/obat/create"
                    element={<CreateObat />}
                  />
                  <Route
                    path="/obat-paket/obat/edit/*"
                    element={<EditObat />}
                  />
                  <Route
                    path="/obat-paket/obat/detail/*"
                    element={<ObatDetail />}
                  />
                  {/* <Route
                    path="/obat-paket/obat/edit/:id"
                    element={<EditObat />}
                  /> */}
                  <Route
                    path="/obat-paket/paket/create"
                    element={<CreatePaket />}
                  />
                  <Route
                    path="/obat-paket/paket/update/:name/:outlet"
                    element={<UpdatePaket />}
                  />    
                  <Route path="/obat-paket/paket" element={<ResepPage />} />
                  <Route
                    path="/obat-paket/paket/detail/:name/:outlet"
                    element={<ResepDetail />}
                  />
                  <Route path="*" element={<NotFoundRedirect />} />

                  {/* Inventory Route */}
                  <Route
                    path="/inventory/stock-opname"
                    element={<StockOpname />}
                  />
                  <Route
                    path="/inventory/stock-opname/create"
                    element={<CreateStockOpname />}
                  />
                  <Route
                    path="/inventory/purchase-order"
                    element={<PurchaseOrderList />}
                  />
                  <Route
                    path="/inventory/purchase-order/purchasingorderformadmin"
                    element={<PurchasingOrderFA />}
                  />
                  <Route
                    path="/inventory/purchase-order/detail/:poNumber"
                    element={<PurchaseOrderDetail />}
                  />
                  <Route
                    path="/inventory/purchase-order/details/:poNumber"
                    element={<PurchaseOrderDetails />}
                  />
                  <Route
                    path="/inventory/purchase-order/receive/:poNumber"
                    element={<ReceivePO />}
                  />
                  <Route path="/inventory/invoice" element={<InvoiceList />} />
                  <Route
                    path="/inventory/invoice/create"
                    element={<CreateInvoice />}
                  />
                  <Route
                    path="/inventory/invoice/detail/:invoiceNumber"
                    element={<InvoiceDetail />}
                  />
                  <Route
                    path="/inventory/invoice/form/:poNumber"
                    element={<InvoiceFormPO />}
                  />
                  <Route path="/logs" element={<Logs />} />

                  {/* Rebalance Route */}
                  <Route path="/rebalance" element={<RebalancePage />} />
                  <Route
                    path="/rebalance/create"
                    element={<CreateRebalance />}
                  />
                  <Route
                    path="/rebalance/detail/:id"
                    element={<DetailRebalance />}
                  />

                  {/* Detailed Report Route */}
                  <Route path="/report/salesreport" element={<SalesReport />} />
                  <Route
                    path="/report/monthlyreport"
                    element={<MonthlyReport />}
                  />
                  {/* <Route path="/enterprise/logs" element={<Logs />} /> */}
                  {/* <Route path="/enterprise/logsother" element={<LogOther />} /> */}
                  <Route
                    path="/detailed-report"
                    element={<DetailedReportPage />}
                  />
                  <Route path="*" element={<Navigate to="/" />} />
                  {/* Redirect jika path tidak ditemukan */}
                </Routes>
              </div>
            </div>
          </div>
        ) : (
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/login" />} />{" "}
            {/* Redirect ke login jika belum login */}
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
